import { ITerms } from 'src/models';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 약관 조회 */
export const getTermsList = async (termsTypeCd: number) => {
  try {
    const url = `/terms?termsType=${termsTypeCd}`;

    const response = await instance.get<TApiResponseData<ITerms[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
